<template>
    <Form @submit="submit" :validation-schema="schema">
        
        <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden mt-1">
            <div class=" bg-[#2B2C32] px-[16px] py-[6px] rounded-xl border-2" :class="(!form.badge_running || form.on_hold)?'border-theme-red':'border-theme-green'">
                <div class="flex justify-between text-theme-878686">
                    <span class="text-sm tracking-wide font-normal">Lot #</span>
                    <div>
                        <span class="text-sm tracking-wider font-bold mr-5">Packaged On: {{getPackageDate()}}</span>
                        <span class="text-sm tracking-wider font-bold">Created At: {{getCreatedDate()}}</span>
                    </div>
                </div>
                

                <div class="flex justify-between">
                    <div class="flex justify-center">
                        <div class="text-xl tracking-wider"><input  :disabled="form.current_nou==0 || form.on_hold" v-model="form.batch_lot" placeholder="Please enter your lot name" type="text" class="block font-normal border-none focus:ring-0 rounded bg-gray-black w-full text-sm placeholder-theme-878686"/></div>
                        <div class="ml-3 self-center">
                            <span v-if="form.on_hold" class="text-theme-red">Lot on hold (can not sell)</span>
                            <span v-else class="text-theme-green">Sellable</span>
                        </div>
                    </div>
                    <div class="mt-1 flex gap-2 ">
                        <button @click.prevent="archive" class="flex justify-center items-center gap-2 bg-[#F53333] rounded px-3">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9583 0.958333L15.1167 2.35833C15.3583 2.64167 15.5 3.01667 15.5 3.41667V13.8333C15.5 14.75 14.75 15.5 13.8333 15.5H2.16667C1.25 15.5 0.5 14.75 0.5 13.8333V3.41667C0.5 3.01667 0.641667 2.64167 0.883333 2.35833L2.03333 0.958333C2.26667 0.675 2.60833 0.5 3 0.5H13C13.3917 0.5 13.7333 0.675 13.9583 0.958333ZM12.8 2.16667H3.2L2.53333 2.975H13.475L12.8 2.16667ZM2.16667 13.8333V4.66667H13.8333V13.8333H2.16667ZM6.79167 6.33333H9.20833V8.83333H11.3333L8 12.1667L4.66667 8.83333H6.79167V6.33333Z" fill="white"/>
                            </svg>
                            <span>Archive</span>
                        </button>
                        <label class="flex items-center cursor-pointer">
                            <input :disabled="form.current_nou==0 || form.on_hold" type="checkbox" v-model="form.badge_running" class="hidden">
                            <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.badge_running ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                        </label>
                    </div>
                </div>

                <div class="flex gap-3 xl:flex-row flex-col items-start mt-2 mb-1">
                    <!-- thc is not set or single thc -->
                    <div class="w-full xl:w-3/12" :class="(!productCbdThcType || productCbdThcType=='single')?'':'hidden'">
                        <div class="input-wrapper relative">
                            <Field v-slot="{field, errors, errorMessage}" name="thc" v-model.number="form.thc">
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">THC</label>
                                <div v-if="editVariant.complianceType && editVariant.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <div v-else class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-1">{{editVariant.concentration_unit}}</span>
                                    <input v-model.number="form.thc" :disabled="form.current_nou==0 || form.on_hold" placeholder="20.5" class="block tracking-wider border-none focus:ring-0 rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-sm"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                            </Field>
                        </div>
                    </div>
                    <!-- thc is range -->
                    <div class="w-full xl:w-3/12" :class="(productCbdThcType=='range')?'':'hidden'">
                        <div class="input-wrapper">
                            <label class="text-xs">THC ({{editVariant.concentration_unit}})</label>
                            <div class="flex">
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="thcMin" v-model.number="form.thcMin">
                                        <div v-if="editVariant.complianceType && editVariant.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                        <input v-else v-model.number="form.thcMin" :disabled="form.current_nou==0 || form.on_hold" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                        <div v-else class="text-xs">&nbsp;</div>
                                    </Field>
                                </div>
                                <span class="flex mt-4 mx-1">
                                    <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                                    </svg>
                                </span>
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="thcMax" v-model.number="form.thcMax">
                                        <div v-if="editVariant.complianceType && editVariant.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                        <input v-else v-model.number="form.thcMax" :disabled="form.current_nou==0 || form.on_hold" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                        <div v-else class="text-xs">&nbsp;</div>
                                    </Field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- cbd is not set or single cbd -->
                    <div class="w-full xl:w-3/12" :class="(!productCbdThcType || productCbdThcType=='single')?'':'hidden'">
                        <div class="input-wrapper relative">
                            <Field v-slot="{field, errors, errorMessage}" name="cbd" v-model.number="form.cbd">
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">CBD</label>
                                <div v-if="editVariant.complianceType && editVariant.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <div v-else class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-1">{{editVariant.concentration_unit}}</span>
                                    <input v-model.number="form.cbd" :disabled="form.current_nou==0 || form.on_hold" placeholder="20.5" class="block tracking-wider focus:ring-0 border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-sm"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                            </Field>
                        </div>
                    </div>
                    <!-- cdb is range -->
                    <div class="w-full xl:w-3/12" :class="(productCbdThcType=='range')?'':'hidden'">
                        <div class="input-wrapper">
                            <label class="text-xs">CBD ({{editVariant.concentration_unit}})</label>
                            <div class="flex">
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="cbdMin" v-model.number="form.cbdMin">
                                        <div v-if="editVariant.complianceType && editVariant.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                        <input v-else :disabled="form.current_nou==0 || form.on_hold" v-model.number="form.cbdMin" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                        <div v-else class="text-xs">&nbsp;</div>
                                    </Field>
                                </div>
                                <span class="flex mt-4 mx-1">
                                    <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                                    </svg>
                                </span>
                                <div class="relative w-full">
                                    <Field v-slot="{field, errors, errorMessage}" name="cbdMax" v-model.number="form.cbdMax">
                                        <div v-if="editVariant.complianceType && editVariant.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                        <input v-else :disabled="form.current_nou==0 || form.on_hold" v-model.number="form.cbdMax" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                        <div v-else class="text-xs">&nbsp;</div>
                                    </Field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-full xl:w-2/12">
                        <div class="input-wrapper">
                            <Field v-slot="{field, errors, errorMessage}" name="totalTerp" v-model="form.totalTerp" >
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">Terps</label>
                                <div v-if="editVariant.complianceType && editVariant.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                <div v-else class="flex flex-row rounded bg-gray-black ">
                                    <span class="mt-1 ml-2">%</span>
                                    <input :disabled="form.current_nou==0 || form.on_hold" :onkeypress="preventNonNumbersAndDecimal" v-model="form.totalTerp" placeholder="4.0" min="0" class="block tracking-wider border-none focus:ring-0 rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                                </div>
                                <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                <div v-else class="text-xs">&nbsp;</div>
                            </Field>
                        </div>
                    </div>

                    <div class="w-full xl:w-2/12">
                        <div class="input-wrapper relative">
                            <label class="text-xs" :class="form.current_nou?'text-theme-green':''">Inv Count</label>
                            <input disabled v-model="form.current_nou" placeholder="24" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                    </div>
                    <div class="w-full xl:w-2/12">
                        <div class="input-wrapper relative">
                            <Field v-slot="{field, errors, errorMessage}" name="cost" v-model.number="form.cost">
                                <label class="text-xs" :class="labelClass(field.value, errorMessage)">Cost</label>
                                <span class="absolute top-[33px] left-3">
                                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                                    </svg>
                                </span>
                                <input :disabled="form.current_nou==0 || form.on_hold" @wheel.prevent v-model.number="form.cost" placeholder="39.99" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                                <div v-if="errors.length>0" class="text-sm"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                            </Field>
                        </div>
                    </div>
                </div>
                <div v-if="edit" class="flex justify-center mt-4" data-v-bcd78aca="">
                    <button class="rounded bg-theme-green uppercase text-white px-[140px] py-[14px] text-sm tracking-wider font-medium">Confirm</button>
                </div>
            </div>
        </div>
    </Form>
</template>
<script>
import {Form, Field} from 'vee-validate'
import { ref, defineComponent } from 'vue'
import {mapGetters, mapMutations} from 'vuex'
import moment from 'moment'
import pick from 'lodash/pick'
import Helpers from '@/helpers';
import ObjectHelper from '@/helpers/object'
import { useSnackbar } from "vue3-snackbar"
import ProductApi from '@/controllers/BusinessProductApis'

export default defineComponent({
    components: {
        Form,
        Field
    },
    props: ['editVariant', 'lot', 'productCbdThcType', 'lotNamesExceptThis'],
    setup() {
        const snackbar = useSnackbar();
        const edit = ref(false)
        const form = ref({})
        const loading = ref(true)

        const schema = {
            thc: 'price',
            thcMin: 'price',
            thcMax: 'price',
            cbd: 'price',
            cbdMin: 'price',
            cbdMax: 'price',
            cost: 'price',
            totalTerp: 'percentage'
        }

        return {snackbar, edit, form, schema, loading}
    },
    mounted(){
        this.loading = true
        this.form = pick(this.lot, ['thc', 'cbd', 'thcMin', 'thcMax', 'cbdMin', 'cbdMax', 'badge_running', 'current_nou', 'cost', 'batch_lot', 'packaged_on', 'on_hold', 'totalTerp'])
        this.form.thc_cbd_value_type = this.productCbdThcType?this.productCbdThcType:'single'
    },
    watch: {
        form: {
            handler(){
                if(!this.loading){
                    this.edit = true
                }
                this.loading = false
            },
            deep: true
        },
        lot(){
            this.form = pick(this.lot, ['batch_lot','thc', 'cbd', 'thcMin', 'thcMax', 'cbdMin', 'cbdMax', 'badge_running', 'current_nou', 'cost', 'batch_lot', 'packaged_on', 'on_hold', 'totalTerp'])
            this.form.thc_cbd_value_type = this.productCbdThcType?this.productCbdThcType:'single'
        },
        // productCbdThcType(val){
        //     this.form.thc_cbd_value_type = val?val:'single'
        // }
    },
    computed: {
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected'
        })
    },
    methods: {
        labelClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }else if(value){
                return 'text-theme-green'
            }
        },
        inputClass(value, error){
            if(value && error){
                return 'border-theme-red'
            }else if(error){
                return 'border-theme-orange'
            }else if(value){
                return 'border-theme-green'
            }
        },
        errorClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }
        },
        getPackageDate(){
            if(this.lot){
                if(this.lot.packaged_on){
                    let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
                    return moment(this.lot.packaged_on).tz(defaultTimeZone).format('YYYY-MM-DD');
                }
                
            }
        },
        getCreatedDate(){
            if(this.lot){
                let defaultTimeZone = this.vg_selectedLocation.timezone?this.vg_selectedLocation.timezone:'America/Toronto';
                return moment(this.lot.createdAt).tz(defaultTimeZone).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        archive(){
            this.confirmNew('Archive', 'This is a permanent action. Are you sure you want to archive this lot?').then(async () => {
                this.vm_spinner(true)
                let res = await ProductApi.archive(this.lot.id)
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                if(res.status==200){
                    this.$emit('updatedLot')
                }
                this.vm_spinner(false)
            }).catch(e => {})
        },
        async submit(){

            if(this.form.batch_lot == '') {
                return this.snackbar.add({
                    type: 'info',
                    text: 'Please add lot name.',
                    duration: 3000,
                })
            } else if(this.lotNamesExceptThis.indexOf(this.form.batch_lot.trim()) >  -1) {
                return this.snackbar.add({
                    type: 'info',
                    text: 'Batch lot name already exist.',
                    duration: 3000,
                })
            }

            this.vm_spinner(true)
            this.form.locationId = this.vg_selectedLocation.id
            let res = await ProductApi.updateProductLot(this.lot.id, ObjectHelper.emptyStringToNull(this.form))
             this.snackbar.add({
                type: 'info',
                text: res.status == 200 ? "Lot updated successfully." : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            this.edit = false
            this.vm_spinner(false)
            this.emitter.emit('reloadEditVariant', this.editVariant)
            this.emitter.emit('reloadProductList', true)
        },
        preventNonNumbersAndDecimal(e) {
          var ASCIICode = (e.which) ? e.which : e.keyCode
          if(ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101 || e.which == 8 || ASCIICode !== 46 && ASCIICode != 0 && (ASCIICode < 48 || ASCIICode > 57)){
            return false
          }
          return true;
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>
